import { request } from '@/services/http';
import type { OnboardingState } from '../model/types';

const BASE_URL = '/onboarding';

export const onboardingService = {
  async getState(): Promise<OnboardingState> {
    return request<OnboardingState>(BASE_URL);
  },

  async updateState(data: Partial<OnboardingState>): Promise<OnboardingState> {
    return request<OnboardingState>(BASE_URL, {
      method: 'PUT',
      json: data,
    });
  },

  async markSectionHovered(sectionId: string): Promise<OnboardingState> {
    return request<OnboardingState>(`${BASE_URL}/hover`, {
      method: 'POST',
      json: { sectionId },
    });
  },

  async completeStep(stepId: string): Promise<OnboardingState> {
    return request<OnboardingState>(`${BASE_URL}/complete-step`, {
      method: 'POST',
      json: { stepId },
    });
  },

  async complete(): Promise<OnboardingState> {
    return request<OnboardingState>(`${BASE_URL}/complete`, {
      method: 'POST',
    });
  },

  async skip(): Promise<OnboardingState> {
    return request<OnboardingState>(`${BASE_URL}/skip`, {
      method: 'POST',
    });
  },

  async reset(): Promise<OnboardingState> {
    return request<OnboardingState>(`${BASE_URL}/reset`, {
      method: 'POST',
    });
  },
};
